import { FC, useCallback } from "react";
import mapIllustration from "@modules/for-you/assets/images/zero_state_map_illustration.svg";
import Image from "next/legacy/image";
import { useHousehold, useMeClient } from "@common/queries";
import { advisorMeetingSetup } from "@common/utils";
import { useUser } from "@auth0/nextjs-auth0/client";
import { useBreakpoints } from "@common/hooks";
import { Button, Typography } from "@earned/core";

const ReportsZeroState: FC = () => {
  const { data: household } = useHousehold();
  const { data: client } = useMeClient();
  const { user } = useUser();
  const { isMobile } = useBreakpoints();

  const handleSetupAdvisorMeeting = useCallback(() => {
    const meetingProps = advisorMeetingSetup(
      household?.primaryWealthAdvisor,
      user as Forme.Claims,
      client
    );
    window.Calendly.initPopupWidget(meetingProps);
  }, [user, household, client]);

  return (
    <div className="flex flex-1 flex-col justify-between">
      <div className="max-w-[600px] space-y-5 pb-7">
        <Typography variant="title-2xl" color="primary" weight="medium">
          Begin your journey to personalized advice
        </Typography>
        <Typography variant="body-lg" color="secondary">
          Work with our expert advisors for insurance optimization, tax
          planning, career advice and contract review, ongoing financial
          planning and management of your retirement assets, and more. All
          powered by our Intelligent Advice Engine&trade;.
        </Typography>
        <Button variant="primary" onClick={handleSetupAdvisorMeeting}>
          Get Started
        </Button>
      </div>
      <div className="flex justify-end">
        <Image
          src={mapIllustration}
          height={isMobile ? 117 : 237}
          width={isMobile ? 180 : 365}
        />
      </div>
    </div>
  );
};

export default ReportsZeroState;
